module.exports = __webpack_public_path__ + "img/zbf_zombiecointk.5bee187.png";